import { render, staticRenderFns } from "./EditArticle.vue?vue&type=template&id=7efcbe6c&scoped=true&"
import script from "./EditArticle.ts?vue&type=script&lang=ts&"
export * from "./EditArticle.ts?vue&type=script&lang=ts&"
import style0 from "./EditArticle.vue?vue&type=style&index=0&id=7efcbe6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efcbe6c",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QInput,QSelect,QItem,QItemSection,QRadio,QToggle,QBtn});
